export default function Track(props) {
  return (
    <div className="track">
      <div className="track-name">{props.trackName}</div>
      <div className="track-length">{props.length}</div>
    </div>
  );
}